import { Suspense } from "react";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import { SnackbarProvider } from "../Components/SnackBar";
import CommunityLayout from "../Layouts/CommunityLayout";
import ScrollToTop from "../Utils/ScrollToTop";
import { useTranslation } from "react-i18next";
import { communityRoutes, sharedRoutes, supplierRoutes } from "./routePaths";
// import i18n from "i18next";

// import { useCookie } from "../Context/CookieContext";

function RouteElements() {
  const { t } = useTranslation("routes-and-main-menu");

  const isCommunityManagementRole =
    localStorage.getItem("isCommunityManagementRole") === "true";

  const roleRoutes = isCommunityManagementRole
    ? communityRoutes
    : supplierRoutes;

  const element = useRoutes(
    [...roleRoutes, ...sharedRoutes].map((route) => ({
      path: route.path,
      element: (
        <CommunityLayout
          title={route.title ? t(route.title + ".title") : ""}
          hideTitle={route.hideTitle ?? false}
          mobileTitleOnly={route.mobileTitleOnly ?? false}
        >
          {route.element}
        </CommunityLayout>
      ),
    })),
  );

  return element;
}

function AppRoutes() {
  //   const { isValid } = useCookie();

  // if (!isValid) {
  //     // Redirect to your Onboarding project's login URL
  //     //window.location.href = process.env.REACT_APP_LOGIN_URL || 'http://localhost:3000/login';

  //     return null;
  // }

  return (
    <SnackbarProvider>
      <Router>
        <ScrollToTop />
        <Suspense fallback={null}>
          <RouteElements />
        </Suspense>
      </Router>
    </SnackbarProvider>
  );
}

export default AppRoutes;
